module.exports = __webpack_public_path__ + "static/media/banner02.09ee6ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/banner02.jpg
// module id = 138
// module chunks = 0